export default "__VITE_ASSET__CinZlw7e__"